import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import Layout from './components/Layout';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Despacho from './pages/Despacho';
import Incidentes from './pages/Incidentes';
import Historial from './pages/Historial';
import AdminUsuarios from './pages/AdminUsuarios';
import PrediccionIA from './pages/PrediccionIA';
import Respuestas from './pages/Respuestas';

const RutaPrivada = ({ children }) => {
  const { sesion } = useAuth();
  return sesion ? children : <Navigate to="/login" />;
};

const SoloDashboard = () => {
  const { esBombero } = useAuth();
  return esBombero() ? <Navigate to="/despacho" replace /> : <Dashboard />;
};

RutaPrivada.propTypes = {
  children: PropTypes.node.isRequired,
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Todas las rutas privadas comparten el mismo Layout (sidebar + topbar) */}
          <Route element={<RutaPrivada><SocketProvider><Layout /></SocketProvider></RutaPrivada>}>
            <Route path="/"            element={<SoloDashboard />} />
            <Route path="/incidentes"  element={<Incidentes />} />
            <Route path="/despacho"    element={<Despacho />} />
            <Route path="/respuestas"  element={<Respuestas />} />
            <Route path="/prediccion"  element={<PrediccionIA />} />
            <Route path="/historial"   element={<Historial />} />
            <Route path="/usuarios"    element={<AdminUsuarios />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
